<template lang='pug'>
    v-dialog(v-model="changeManagementNotif" id="modal" transition="dialog-bottom-transition" width="40%" class="test-dialog")
        v-card(class="dialog-card")
            v-card-title(class="headline grey lighten-2"
            primary-title) Notification
            v-card-text
              h3(style="text-align: center; font-weight:normal;") Mulai tanggal 01 Januari 2022 IM non group akan pindah ke <a href="https://imnongroup.it-smm.id/" target="_blank">imnongroup.it-smm.id</a>
              <br/>
              v-card-actions
                v-spacer
                v-btn(color="green darken-1" flat="flat" @click="toggleChangeManagementNotif") Tutup
</template>

<script>
import { mapMutations, mapState } from "vuex";
  export default {
    name: 'ChangeManagementNotif',
    computed: {
      ...mapState(["changeManagementNotif"]),
    },
    methods: {
    ...mapMutations(["toggleChangeManagementNotif"])
    },
  };
</script>

<style>
  
</style>

    